import { CurrencyPipe, PercentPipe } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { DummySimulation, SimulationService } from '@services/simulation.service';
import { ViewState } from '@utils/view-state.utils';

@Component({
  imports: [
    CurrencyPipe,
    PercentPipe,
  ],
  selector: 'app-dummy-simulation-page',
  styleUrl: './dummy-simulation.page.scss',
  templateUrl: './dummy-simulation.page.html',
})
export class DummySimulationPage {
  protected viewState = signal<ViewState<DummySimulation, string>>({ status: 'initial' });
  private simulationService = inject(SimulationService);

  protected async simulate(): Promise<void> {
    this.viewState.set({ status: 'loading' });
    try {
      const simulation = await this.simulationService.simulateDummy();
      this.viewState.set({ status: 'success', value: simulation });
    } catch (error) {
      this.viewState.set({ error: JSON.stringify(error), status: 'error' });
      console.error(error);
    }
  }
}
